import { NodeTypes } from 'reactflow';

import { StartNode } from './StartNode';
import { EndNode } from './EndNode';
import PlaceholderNode from './PlaceholderNode';
import { ActionNode } from './ActionNode';
import { TriggerNode } from './TriggerNode';

export enum AutomationNodeType {
  trigger = 'trigger',
  action = 'action',
  start = 'start',
  end = 'end',
  placeholder = 'placeholder',
}

const nodeTypes: NodeTypes = {
  start: StartNode,
  end: EndNode,
  placeholder: PlaceholderNode,
  action: ActionNode,
  trigger: TriggerNode,
};

export default nodeTypes;
